import { Routes, Route } from "react-router-dom";
import { AboutUs } from "./Components/AboutUs";
import "./App.css";
import { Home } from "./Components/Home";
import { B2BAgents } from "./Components/B2BAgents";
import { ContactUs } from "./Components/ContactUs";
// import { Corporate } from "./Components/Corporate";
import { India } from "./Components/Destinations/India";
import { CustomItinerary } from "./Components/CustomItinerary";
import Experiences from "./Components/Experiences";
import ExperienceBlogs from "./Components/ExperienceBlogs";
import { Kenya } from "./Components/Destinations/Kenya";
import { Journal } from "./Components/Journal";
import BlogInner from "./Components/BlogInner";
// import { Kazakhstan } from "./Components/Destinations/Kazakhstan";
import { Qatar } from "./Components/Destinations/Qatar";
import { Malaysia } from "./Components/Destinations/Malaysia";
import { SouthAfrica } from "./Components/Destinations/South Africa";
import { Zambia } from "./Components/Destinations/Zambia";
import { Zimbabwe } from "./Components/Destinations/Zimbabwe";
import { Tanzania } from "./Components/Destinations/Tanzania";
import { Uganda } from "./Components/Destinations/Uganda";
// import { Rwanda } from "./Components/Destinations/Rwanda";
import { UAE } from "./Components/Destinations/UAE";
import { Singapore } from "./Components/Destinations/Singapore";
import TermsAndConditions from "./Components/Terms&Conditions";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import { MedicalTourism } from "./Components/MedicalTourism";

function App() {
  return (
    <>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/medical" element={<MedicalTourism />} />
          <Route path="/b2b-agents" element={<B2BAgents />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/blog" element={<Journal />} />
          <Route path="/blog/:slug" element={<BlogInner />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/experiences/:id" element={<ExperienceBlogs />} />
          
          <Route path="/destination/india" element={<India />} />
          <Route path="/destination/:country/:slug" element={<CustomItinerary />} />

          <Route path="/destination/kenya" element={<Kenya />} />
          <Route path="/destination/kenya/:slug" element={<CustomItinerary />} />

         
          
          <Route path="/destination/south-africa" element={<SouthAfrica />} />
          <Route path="/destination/south-africa/:slug" element={<CustomItinerary />} />

          <Route path="/destination/tanzania" element={<Tanzania />} />
          <Route path="/destination/tanzania/:slug" element={<CustomItinerary />} />
{/* 
          <Route path="/destination/rwanda" element={<Rwanda />} />
          <Route path="/destination/rwanda/:slug" element={<CustomItinerary />} /> */}

          <Route path="/destination/uganda" element={<Uganda />} />
          <Route path="/destination/uganda/:slug" element={<CustomItinerary />} />

          <Route path="/destination/zambia" element={<Zambia />} />
          <Route path="/destination/zambia/:slug" element={<CustomItinerary />} />

          <Route path="/destination/zimbabwe" element={<Zimbabwe />} />
          <Route path="/destination/zimbabwe/:slug" element={<CustomItinerary />} />

          <Route path="/destination/qatar" element={<Qatar />} />
          <Route path="/destination/qatar/:slug" element={<CustomItinerary />} />

          <Route path="/destination/malaysia" element={<Malaysia />} />
          <Route path="/destination/malaysia/:slug" element={<CustomItinerary />} />

          <Route path="/destination/uae" element={<UAE />} />
          <Route path="/destination/uae/:slug" element={<CustomItinerary />} />

          <Route path="/destination/singapore" element={<Singapore />} />
          <Route path="/destination/singapore/:slug" element={<CustomItinerary />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
